const TYPES = [
  {title: 'Kích hoạt (6)', value: 'cv6'},
  {title: 'Chuyển đợt 2 (6)', value: 'cv6-retry2'},
  {title: 'Nhập học (6)', value: 'enroll6'},
  {title: 'Lớp HDPPLB (6)', value: 'exam-prep'},
  {title: 'Kích hoạt (10)', value: 'cv10'},
  {title: 'Thi thử (10)', value: 'exam'},
  {title: 'Nhập học (10)', value: 'enroll10'},
]

export {TYPES}
